<template>
  <div class="login">
    <el-row type="flex">
      <el-col class="hidden-md-and-down" :span="10">
        <img :src="image" alt="" style="width: 100%" />
      </el-col>
      <el-col :sm="24" :lg="14">
        <div class="login-section">
          <el-row>
            <el-col :sm="12" :lg="12">
              <h3>會員登入</h3>
            </el-col>
            <el-col :sm="12" :lg="12">
              <p class="w3-right">
                還未有賬號?
                <router-link to="/register" class="my-register-link"
                  >立即註冊</router-link
                >
              </p>
            </el-col>
          </el-row>

          <el-form label-position="top" class="w3-margin-top">
            <el-form-item label="電郵地址">
              <el-input clearable></el-input>
            </el-form-item>
            <el-form-item label="密碼">
              <el-input show-password></el-input>
            </el-form-item>
            <el-form-item>
              <el-row>
                <el-col :sm="24" :lg="12">
                  <el-checkbox label="保持登入狀態"></el-checkbox>
                </el-col>
                <el-col :sm="24" :lg="12">
                  <el-link type="info" class="w3-right">忘記密碼?</el-link>
                </el-col>
              </el-row>
              <el-button @click.prevent="login" class="my-btn">登入</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import LeftImage from "../assets/left-img.png";

export default {
  data() {
    return {
      image: LeftImage,
    };
  },
  methods: {
    login() {
      this.$router.push("/main");
    },
  },
};
</script>

<style>
.login {
  margin: 2rem auto;
  max-width: 1100px;
  background: #fff;
  border-radius: 12px;
}

.login .login-section {
  padding: 6rem 6rem 0 6rem;
}

.login .my-btn {
  background-color: #7a3d87;
  color: #fff;
  border-color: #7a3d87;
  outline-color: #7a3d87;
  width: 100%;
  margin-top: 1rem;
}

.login .my-btn:hover {
  background-color: #793d87d5;
  color: #fff;
  border-color: #793d87d5;
}

.login .my-register-link {
  color: #7a3d87 !important;
  text-decoration: none;
}

.login .my-register-link:hover {
  color: #409eff !important;
}

.login .el-checkbox__label {
  padding-left: 0.3rem !important;
  white-space: normal;
}

.login .el-checkbox.is-checked .el-checkbox__label {
  color: #7a3d87 !important;
}

.login .el-checkbox__inner:hover {
  border-color: #7a3d87 !important;
}

.login .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #7a3d87 !important;
  border-color: #7a3d87 !important;
}
</style>